import { render, staticRenderFns } from "./Sub.vue?vue&type=template&id=4c78a4bf&scoped=true&"
import script from "./Sub.vue?vue&type=script&lang=js&"
export * from "./Sub.vue?vue&type=script&lang=js&"
import style0 from "./Sub.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Sub.vue?vue&type=style&index=1&id=4c78a4bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c78a4bf",
  null
  
)

export default component.exports